import React from 'react';
import i18next from 'i18next';
import classNames from 'classnames';
import InputText from '../../InputText/InputText';
import Icon from '../../Icon/Icon';

import replyIcon from 'icons/reply.svg';

export const MESSAGE_MAX_LEN = 180;

class ChatReply extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      typingMessage: '',
    };

    this.replyRef = props.replyRef;
  }

  onTyping = (e) => {
    const replyTo = this.props.replyTo;
    let message = e.target.value.slice(0, MESSAGE_MAX_LEN);

    if (replyTo) {
      if (
        !message ||
        message === `@${replyTo},` ||
        message.indexOf(replyTo) === -1
      ) {
        this.props.cleanReply();
        message = message === `@${replyTo},` ? '' : message;
      } else {
        message = message.slice(replyTo.length + 1).replace(/^,\s+/, '');
      }
    }

    this.setState({ typingMessage: message });
  };

  onKeyPress = (e) => {
    if (e.key === 'Enter') {
      this.onSend(e);
    }
  };

  onSend = () => {
    const { replyTo } = this.props;
    const { typingMessage } = this.state;

    const message = replyTo ? `@${replyTo}, ${typingMessage}` : typingMessage;

    this.props.onSend(message);
    this.setState({ typingMessage: '' });
    this.replyRef.current.value = '';
  };

  render() {
    const { replyTo, disabled } = this.props;
    const { typingMessage } = this.state;
    const replyClasses = classNames('chat-reply', disabled ? 'disabled' : '');

    const message = replyTo ? `@${replyTo}, ${typingMessage}` : typingMessage;

    return (
      <div className={replyClasses}>
        <InputText
          className="chat-reply__message form-control"
          onChange={this.onTyping}
          onKeyPress={this.onKeyPress}
          value={message}
          inputRef={this.replyRef}
          placeholder={i18next.t('chat.placeholder')}
        />
        <div
          className={'chat-reply__send' + (typingMessage ? '' : ' disabled')}
          onClick={this.onSend}
        >
          <Icon glyph={replyIcon} />
        </div>
      </div>
    );
  }
}

ChatReply.defaultProps = {};

export default ChatReply;



// WEBPACK FOOTER //
// ./app/components/Chat/ChatReply/ChatReply.jsx